<template>
  <van-popup
    v-model="show"
    :closeable="closeable"
    :close-on-click-overlay="closeOnClickOverlay"
    @click-overlay="close"
    :round="round"
    :position="position"
    :get-container="parentContainer"
    :class="[className, layoutVersion, displayLayout]"
  >
    <p class="title" :style="charColorStyle">
      {{ title }}
    </p>
    <p
      class="desc"
      :style="charColorStyle ? { color: 'rgb(255, 255, 255, 0.8)' } : {}"
    >
      {{ desc }}
    </p>
    <template v-if="showBtn">
      <template v-if="onlyOneButton">
        <div :class="['btn-wrapper', 'flex-center']">
          <button @click="handleOK" class="border-btn">
            {{ comfirmText }}
          </button>
        </div>
      </template>
      <template v-else>
        <div
          :class="[
            isLRLayout && isDesktop ? 'btn-LR' : 'btn-wrapper',
            'space-between',
            confirmOnRight ? '' : 'reverse',
            greyBtnOnRight ? 'bg-color-inversion' : '',
          ]"
        >
          <button @click="close" class="cancel-btn" :style="charColorStyle">
            {{ cancelText }}
          </button>
          <button @click="handleOK" class="confirm-btn">
            {{ comfirmText }}
          </button>
        </div>
      </template>
    </template>
    <slot></slot>
  </van-popup>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'common-popup',
    props: {
      isLRLayout: {
        type: Boolean,
        defalut: false,
      },
      thisCharColor: {
        type: String,
        defalut: 'black',
      },
      showPopup: {
        type: Boolean,
        default: false,
      },
      closeable: {
        type: Boolean,
        defalut: false,
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: true,
      },
      round: {
        type: Boolean,
        defalut: false,
      },
      background: {
        type: String,
        defalut: '',
      },
      position: {
        type: String,
        defalut: '',
      },
      parentContainer: {
        type: String,
        defalut: 'body',
      },
      className: {
        type: String,
        defalut: '',
      },
      title: {
        type: String,
        defalut: '',
      },
      desc: {
        type: String,
        defalut: '',
      },
      comfirmText: {
        type: String,
        defalut: '',
      },
      cancelText: {
        type: String,
        defalut: '',
      },
      confirmOnRight: {
        type: Boolean,
        default: true,
      },
      greyBtnOnRight: {
        type: Boolean,
        default: false,
      },
      showBtn: {
        type: Boolean,
        default: true,
      },
      onlyOneButton: {
        type: Boolean,
        defalut: false,
      },
    },
    data() {
      return {
        show: this.showPopup,
      }
    },
    computed: {
      ...mapState(['isApp', 'layoutVersion', 'isDesktop']),
      ...mapGetters(['displayLayout']),
      charColorStyle() {
        return {
          color: this.thisCharColor || null,
        }
      },
    },
    watch: {
      showPopup(val) {
        this.show = val
      },
    },
    methods: {
      ...mapMutations(['setUserInfo']),
      close() {
        this.$emit('closePopup', this.show)
      },
      handleOK() {
        this.$emit('confirm')
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
